var TECL_MegaMenu = {
    Initialise: function() {
        $('.mega-menu h3, .nu-menu h3').on('click', function() {
            if ($(this).next().prop('checked')) {
                $(this).children('.glyphicon').removeClass('glyphicon-chevron-down').addClass('glyphicon-chevron-up');
                $(this).next().prop('checked', false);
            } else {
                $(this).children('.glyphicon').removeClass('glyphicon-chevron-up').addClass('glyphicon-chevron-down');
                $(this).next().prop('checked', true);
            }
        });
    }
};
